import Layout from "../Layout";

const Blog = () => {
  return (
    <Layout>
      <h1 style={{ margin: "5rem 0", textAlign: "center" }}>Blog Page</h1>
    </Layout>
  );
};

export default Blog;
